/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_WorkshopInputs */

const en__field_workshop = /** @type {(inputs: _Field_WorkshopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workshop`)
};

const de__field_workshop = /** @type {(inputs: _Field_WorkshopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workshop`)
};

/**
* | output |
* | --- |
* | "Workshop" |
*
* @param {_Field_WorkshopInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_workshop = /** @type {((inputs?: _Field_WorkshopInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_WorkshopInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_workshop(inputs)
	return de__field_workshop(inputs)
});